import React from 'react'
import Svg, { Circle, Path, SvgProps } from 'react-native-svg'

import useTheme from '@common/hooks/useTheme'

/**
 * Cross-chain "route" mark for the Bridge destination — two endpoints joined by
 * a curved path, deliberately distinct from SwapAndBridgeIcon's two-arrow swap
 * mark so the split Swap / Bridge entries never read as the same action.
 */
const BridgeIcon: React.FC<SvgProps> = ({
  width = 24,
  height = 24,
  color,
  strokeWidth = 1.5,
  ...rest
}) => {
  const { theme } = useTheme()
  const stroke = color || (theme.iconSecondary as string)

  return (
    <Svg width={width} height={height} viewBox="0 0 24 24" fill="none" {...rest}>
      <Circle cx={5.5} cy={17.5} r={2.5} stroke={stroke} strokeWidth={strokeWidth} />
      <Circle cx={18.5} cy={6.5} r={2.5} stroke={stroke} strokeWidth={strokeWidth} />
      <Path
        d="M8 17.5h5a4.5 4.5 0 0 0 0-9H8.5"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="0.1 3.2"
      />
      <Path
        d="M16 6.5h-5.5"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
}

export default BridgeIcon
